import validator from "validator";
import { db } from "../firebase/firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore/lite";
import Swal from "sweetalert2";
export const getData = async (params) => {
  //TODO:obtener projects del sistema
  const data = [];
  const response = collection(db, params);
  const citySnapshot = await getDocs(response);
  citySnapshot.docs.forEach((doc) => {
    data.push({
      id: doc.id,
      ...doc.data(),
    });
  });
  return data;
};

export const querySnapshot = async (NameCollection) => {
  const data = [];
  const q = query(
    collection(db, "projects"),
    where("type", "==", NameCollection)
  );
  const typeSKillSnapshot = await getDocs(q);
  typeSKillSnapshot.forEach((doc) => {
    data.push({
      id: doc.id,
      ...doc.data(),
    });
  });
  return data;
};

export const SaveData = (value) => {
  //TODO: guardar datos en firebase
  const { urlGithub, title, description } = value;
  if (
    validator.isURL(urlGithub) &&
    !validator.isEmpty(title) &&
    !validator.isEmpty(description)
  ) {
    const newCityRef = doc(collection(db, "projects"));
    setDoc(newCityRef, value);
    Swal.fire({
      title: "Success",
      text: "Post Creado",
    });
  } else {
    console.log("error");
  }
};

export const savePost = (typeCollection, data) => {
  // save project and certifications
  const { title, description, repository } = data;
  if (
    validator.isEmpty(title) ||
    validator.isEmpty(description) ||
    !validator.isURL(repository) ||
    validator.isEmpty(typeCollection)
  ) {
    return Swal.fire({
      title: "error",
      text: "error en los campos",
      timer: 1000,
    });
  }
  const addPost = doc(collection(db, typeCollection));
  setDoc(addPost, data);
  Swal.fire({
    title: "Success",
    text: "Post Creado",
  });
};

export const findProjectId = async (params) => {
  const path = params.split("/")[1];
  const idCollection = params.split("/")[2];

  const projectRef = doc(db, path, idCollection);
  const projectSnaphot = await getDoc(projectRef);
  return projectSnaphot.data();
};

export const updateProject = async (params) => {
  // set(ref(db, "projects/", params), {
  // img: "",
  // });
};
